import apiService from './api';
import { DashboardStats, PendingAmountRow, OverdueInvoiceRow, InvoiceItemSearchResult } from '../types/dashboardTypes';

class DashboardService {
  async getDashboardData(date: string): Promise<DashboardStats> {
    const response = await apiService.get<DashboardStats>(`/dashboard?date=${date}`);
    console.log("responseDash:::::::", response)
    return response.data;
  }

  async getMonthlyRevenue(): Promise<any[]> {
    const response = await apiService.get<any[]>('/dashboard/monthly-revenue');
    return response.data;
  }

  async getReceivedAmount(date: string): Promise<any[]> {
    const response = await apiService.get<any[]>(`/dashboard/received-amount?date=${date}`);
    return response.data;
  }

  async getRecentInvoices(): Promise<any[]> {
    const response = await apiService.get<any[]>('/dashboard/recent-invoices');
    return response.data;
  }

  async getRecentPayments(): Promise<any[]> {
    const response = await apiService.get<any[]>('/dashboard/recent-payments');
    return response.data;
  }

  async getPendingAmountList(): Promise<PendingAmountRow[]> {
    const response = await apiService.get<PendingAmountRow[]>('/dashboard/pending-amount');
    return response.data;
  }

  async getExtraAmountList(): Promise<PendingAmountRow[]> {
    const response = await apiService.get<PendingAmountRow[]>('/dashboard/extra-amount');
    return response.data;
  }

  async getOverdueInvoiceList(): Promise<OverdueInvoiceRow[]> {
    const response = await apiService.get<{ status: boolean; data: OverdueInvoiceRow[] }>('/dashboard/overdue');
    return response.data.data;
  }

  async searchInvoiceItems(query: string): Promise<InvoiceItemSearchResult[]> {
    const response = await apiService.get<InvoiceItemSearchResult[]>(
      '/dashboard/search-invoice-items',
      { params: { q: query } }
    );
    return response.data;
  }
}

export const dashboardService = new DashboardService();
export default dashboardService; 
